<template>
  <BApp>
  <div v-if="isLoaded" class="app-container">
      <AppSimpleNavbar v-if="isSimpleNavbar"/>
      <AppNavbar v-else/>
      <main role="main">
        <Messages :style="{ top: isSimpleNavbar ? 0 : '' }" class="position-fixed"/>
        <component :is="layout" v-bind="layoutProps"/>
      </main>
      <AppFooter v-if="!isSimpleNavbar"/>
  </div>
  </BApp>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AppNavbar from './components/Navbar';
import AppSimpleNavbar from './components/SimpleNavbar';
import AppFooter from './components/Footer';
import LayoutDefault from './components/LayoutDefault';
import Messages from './components/Messages';
import { i18n } from '@/config';
import { BApp } from 'bootstrap-vue-next';

const TOKEN_EXPIRES = import.meta.env.VITE_TOKEN_EXPIRES;

export default {
  components: {
    BApp,
    AppNavbar,
    AppSimpleNavbar,
    AppFooter,
    LayoutDefault,
    Messages,
  },
  data() {
    return {
      activityTimeout: null,
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
    };
  },
  computed: {
    ...mapState('product', ['products']),
    ...mapGetters('session', ['isLoggedIn']),

    isLoaded() {
      return !!(i18n.global.messages.value[i18n.global.locale.value]
          && i18n.global.messages.value[i18n.global.fallbackLocale.value]
          && this.products.length
      );
    },
    layout() {
      return this.$route.meta.layout || LayoutDefault;
    },
    layoutProps() {
      return this.$route.meta.layoutProps;
    },
    isSimpleNavbar() {
      return this.$route.meta.navbarType === 'simple';
    },
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.createCookieScript();
        // this.loadProducts();
        this.reloadProducts();
      },
    },
    isLoggedIn(val) {
      this.activityTrigger(val);
    },
  },
  mounted() {
    if (this.isLoggedIn) this.activityTrigger(this.isLoggedIn);
    this.createCookieScript();
  },
  methods: {
    ...mapActions('product', ['loadProducts', 'reloadProducts']),
    ...mapActions('session', ['logout']),
    ...mapActions('alerts', ['showMessage']),
    createCookieScript() {
      const cookieConsentScript = document.getElementById('CookieConsent');
      if (cookieConsentScript) {
        if (i18n.global.locale === 'en') {
          cookieConsentScript.setAttribute('data-culture', 'EN');
        } else {
          cookieConsentScript.setAttribute('data-culture', 'ET');
        }
        window.CookieInformation.loadConsent();
      }
    },
    activityTrigger(val) {
      if (val) {
        this.events.forEach((event) => {
          document.addEventListener(event, this.checkActivity);
        });
      } else {
        this.events.forEach((event) => {
          document.removeEventListener(event, this.checkActivity);
        });
      }
    },
    checkActivity() {
      clearTimeout(this.activityTimeout);
      this.activityTimeout = setTimeout(() => {
        // Log out the user
        const message = {
          type: 'info',
          textKey: 'errors.sessionExpired'
        };
        this.logout();
        this.showMessage(message);
        this.$router.push({
          name: `login-${this.$i18n.locale}`,
          params: { lang: this.$i18n.locale }
        });
      }, TOKEN_EXPIRES);
    },
  },
  metaInfo() {
    const siteTitle = this.$t('meta.title');

    return {
      titleTemplate(title) {
        return title ? `${title} | ${siteTitle}` : siteTitle;
      },
      meta: [
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('meta.keywords')
        },
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('meta.description')
        },
      ],
    };
  },
};
</script>
